import PageShell from "@/components/PageShell";
import OurWorkSection from "@/components/OurWorkSection";
import { SITE } from "@/seoData";

export default function OurWork() {
  const canonical = `${SITE}/our-work`;
  const seo = {
    title: "Our Work: Before & After Junk Removal Photos | CleanOut247 San Diego",
    description: "Before-and-after photos from real CleanOut247 junk removal jobs across 4S Ranch, Rancho Bernardo, Poway and all of San Diego County.",
    canonical,
    jsonLd: [
      { "@context": "https://schema.org", "@type": "CollectionPage", name: "CleanOut247 Junk Removal Job Photos", url: canonical, about: { "@id": SITE + "/#business" } },
      { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE + "/" },
        { "@type": "ListItem", position: 2, name: "Our Work", item: canonical },
      ] },
    ],
  };
  return (
    <PageShell seo={seo} eyebrow="Our Work" h1="Junk Removal Before & After Photos"
      lead="Real jobs from real San Diego County customers — garages, estates, single items and commercial cleanouts, photographed before and after we hauled it away.">
      <OurWorkSection />
    </PageShell>
  );
}
